import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { ToastMessage, type } from "@/lib/toastr";
import { cn } from "@/lib/utils";
import { changePassword } from "@/services/Auth.service";
import { zodResolver } from "@hookform/resolvers/zod";
import { useMutation } from "@tanstack/react-query";
import { EyeClosed, Loader2 } from "lucide-react";
import { useForm } from "react-hook-form";
import { Link, useLocation, useNavigate } from "react-router";
import { z } from "zod";
import Logo from "../../assets/texpress.png";
import { useEffect, useState } from "react";
import {
  ConfirmPasswordError,
  PasswordError,
} from "@/components/PasswordError";
import { VscEye } from "react-icons/vsc";

export const formSchema = z.object({
  newPassword: z.string().nonempty(),
  confirmPassword: z.string().nonempty(),
});
const ResetPasswordSuccess = () => {
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    if (location?.state?.status === undefined) navigate("/");
  }, []);

  return (
    <div className="flex flex-col items-center justify-center gap-6 min-h-svh bg-muted ">
      <div className="flex flex-col items-center gap-6">
        <Link to="/">
          <img src={Logo} className="h-10" />
        </Link>
        <Card className="w-full lg:w-[522px] p-6">
          <CardHeader
            className="text-center lg:w-[480px] 
            mx-auto
          "
          >
            <CardTitle className="text-2xl font-medium">
              Password reset success
            </CardTitle>
            <CardDescription className="">
              Your new password has been successfully created. you can now
              proceed to log into your account with new password
            </CardDescription>
          </CardHeader>
          <CardContent>
            <Link
              to="/"
              className="w-full bg-gradient-to-r from-primary to-primary-2 h-14 rounded-[10px] p-[10px]
              flex items-center justify-center text-center text-white
              "
            >
              Back to Login
            </Link>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default ResetPasswordSuccess;
